export const firebaseConfig = {
    "apiKey": "AIzaSyD5ALmh2TMW_FI1iGLdvyZsBzFINGcuvvo",
    "authDomain": "justgr.firebaseapp.com",
    "databaseURL": "https://justgr-default-rtdb.europe-west1.firebasedatabase.app",
    "messagingSenderId": "79163484862",
    "projectId": "justgr",
    "storageBucket": "justgr.appspot.com"
};